import { useIntl } from 'react-intl';
import { toPossessive } from './possessive';

/**
 * The active locale's possessive form of a pet name, ready to be passed as the
 * `{name}` argument of a message.
 *
 * `toPossessive` needs a locale and is kept pure so it can stay identical to
 * petcon's copy. This wrapper exists so the call sites — all of them headings of
 * the form "{name} neuer Plan" — read the same as the `toGermanPossessive(pet?.name)`
 * they replaced, instead of each component having to pull in `intl` only to reach
 * `intl.locale`.
 */
export const usePossessiveName = (name?: string | null): string => {
  const intl = useIntl();

  return toPossessive(name, intl.locale);
};
